<script>
    import { get_stock } from '/srv/web/wyvr/html/releases/58819/gen/client/shop/core/product/get_stock.js?1733898724662';
    import { get_attribute_name } from '/srv/web/wyvr/html/releases/58819/gen/client/shop/core/attributes.js?1733898724662';

    wyvr: {
        render: 'hydrate';
        loading: 'lazy';
    }

    export let product;
    $: stock = get_stock(product);
    $: in_stock = stock?.is_in_stock || false;
    $: delivery_time = get_attribute_name(product, 'kw_delivery_time');
</script>

{#if in_stock && delivery_time}
    <div class="m-product-delivery-status">
        <span class="icon-truck" /> <span class="delivery-status">{window.__('product.ready_for_shipment')}</span>
        <span class="delivery-time">{window.__('product.delivery_time', { value: delivery_time })}</span>
    </div>
{/if}